import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiError, AuthService, MessageService } from '../../../../../../../core';
import { Cliente } from '../../../../../../pessoa/cliente/cliente';
import { ClienteCrudHttpService } from '../../../../../../pessoa/cliente/services';
import { TypeaheadClienteComponent } from '../../../../../../pessoa/cliente/typeahead/typeahead-cliente.component';
import { UsuarioRepresentanteHttpService } from '../../../../../../usuario';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sgt-negocio-form-insert-step-cliente',
    templateUrl: './negocio-form-insert-step-cliente.component.html',
    styleUrls: ['./negocio-form-insert-step-cliente.component.less']
})
export class NegocioFormInsertStepClienteComponent  {
    /** Se é o primeiro step */
    @Input() isFirstStep = false;

    @Input() idCliente: number;
    @Output() idClienteChange = new EventEmitter<number>();
    @Input() cliente: Cliente;
    @Output() clienteChange = new EventEmitter<Cliente>();

    @Output() idUsuarioResponsavelChange = new EventEmitter<number>();

    @Output() previus = new EventEmitter<void>();
    @Output() next = new EventEmitter<void>();

    @ViewChild('clienteTypeaead') clienteTypeaead: TypeaheadClienteComponent;

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private usuarioRepresentanteHttpService: UsuarioRepresentanteHttpService) { }

    setFocus() {
        this.clienteTypeaead?.setFocus();
    }

    onSelected(cliente: Cliente) {
        this.idCliente = cliente?.id ?? null;
    }

    onClear() {
        this.idCliente = null;
    }

    private findCliente(idCliente: number): Promise<Cliente> {
        return new Promise<Cliente>((resolve, reject) => {
            this.clienteCrudHttpService.find(idCliente)
                .pipe(
                    take(1)
                )
                .subscribe(
                    cliente => resolve(cliente),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o cliente selecionado para criar um novo negócio', error);
                        reject(error);
                    }
                );
        });
    }

    /** Obtem o id do usuário vinculado ao representante do cliente */
    private getIDUsuarioRepresentanteCliente(idRepresentante: number): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.usuarioRepresentanteHttpService.getId(idRepresentante)
                .pipe(
                    take(1)
                )
                .subscribe(
                    id => resolve(id),
                    () => resolve(null)
                );
        });
    }

    async nextClick() {
        let idUsuarioResponsavel: number;

        if (this.cliente) {
            this.idCliente = this.cliente.id;
            this.cliente = await this.findCliente(this.idCliente);

            // Obtendo o usuário do representante do cliente
            if (this.cliente.idRepresentante) {
                idUsuarioResponsavel = await this.getIDUsuarioRepresentanteCliente(this.cliente.idRepresentante);
            }
        } else {
            this.idCliente = null;
            this.cliente = null;
        }

        if (!idUsuarioResponsavel) {
            idUsuarioResponsavel = this.authService.getIdUsuario();
        }

        this.idClienteChange.emit(this.idCliente);
        this.clienteChange.emit(this.cliente);
        this.idUsuarioResponsavelChange.emit(idUsuarioResponsavel);
        this.next.emit();
    }
}
